import { F as FormatDuration, d as defineCustomElement$1 } from './format-duration.js';

const TtFormatDuration = FormatDuration;
const defineCustomElement = defineCustomElement$1;

export { TtFormatDuration, defineCustomElement };
